export enum AiChatMessageTypeEnum {
    userPrompt,
    aiMessage,
}
